import { useTranslation } from 'react-i18next';
import { Icon } from '../Icon';
import type { useSmilesImport } from '../../hooks/useSmilesImport';

interface SmilesImportPanelProps {
  readonly smilesImport: ReturnType<typeof useSmilesImport>;
}

export function SmilesImportPanel({ smilesImport }: SmilesImportPanelProps) {
  const { t } = useTranslation();
  const { smilesInput, updateSmilesInput, smilesImportState, handleSmilesImport } = smilesImport;

  return (
    <section className="smiles-import-panel" aria-labelledby="smiles-import-heading">
      <div>
        <h2 id="smiles-import-heading">{t('smilesImportPanel.heading')}</h2>
        <p>{t('smilesImportPanel.subheading')}</p>
      </div>
      <form onSubmit={(event) => void handleSmilesImport(event)}>
        <label htmlFor="smiles-input">{t('smilesImportPanel.label')}</label>
        <input
          id="smiles-input"
          type="text"
          value={smilesInput}
          placeholder={t('smilesImportPanel.placeholder')}
          spellCheck="false"
          onChange={(event) => updateSmilesInput(event.target.value)}
        />
        <button
          className={smilesImportState.state === 'loading' ? '' : 'icon-button'}
          type="submit"
          aria-label={t('smilesImportPanel.importButton')}
          title={t('smilesImportPanel.importButton')}
          disabled={smilesImportState.state === 'loading'}
        >
          {smilesImportState.state === 'loading' ? t('smilesImportPanel.importing') : <Icon name="arrowForward" />}
        </button>
      </form>
      {smilesImportState.state === 'error' ? (
        <p className="import-error" role="alert">
          {t('smilesImportPanel.importFailed', { message: smilesImportState.message })}
        </p>
      ) : null}
      {smilesImportState.state === 'success' ? (
        <p className="import-success" role="status">
          {t('smilesImportPanel.importedAs', { canonicalSmiles: smilesImportState.canonicalSmiles })}
        </p>
      ) : null}
    </section>
  );
}
